import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { ProtectedRoute } from "@/core/auth/guards/ProtectedRoute";
import { DashboardPage } from "@/features/dashboard/pages/DashboardPage";
import { LoginPage } from "@/features/user/pages/LoginPage";
import { FormCreatePage } from "@/features/forms/pages/FormCreatePage";
import { FormDetailsPage } from "@/features/forms/pages/FormDetailsPage";
import { FormEditPage } from "@/features/forms/pages/FormEditPage";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { AppLayout } from "@/shared/layouts/AppLayout";
import { AuthLayout } from "@/shared/layouts/AuthLayout";

function SignedOutRoute() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingSpinner fullScreen message="Loading your session..." />;
  return user ? <Navigate to="/" replace /> : <Outlet />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<SignedOutRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
        </Route>
      </Route>
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/b/:businessId/forms/new" element={<FormCreatePage />} />
        <Route path="/b/:businessId/forms/:formId" element={<FormDetailsPage />} />
        <Route path="/b/:businessId/forms/:formId/edit" element={<FormEditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
